














































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import listBase from '@/lib/listbase';
import PageRequest from '@/store/entities/page-request';
import VWidget from '@/components/VWidget.vue';
import FormBase from '@/components/helper/form-base.vue';
import Holiday from '@/store/entities/casis/holiday';

class PageHolidayRequest extends PageRequest {
    year: number = parseInt(Util.abp.clock.today().substr(0, 4));
}

@Component({
    components: { VWidget, FormBase }
})
export default class Holidays extends listBase {
    entity: string = 'holiday';
    pagerequest: PageHolidayRequest = new PageHolidayRequest();
    holiday: Holiday = new Holiday();
    modalShow: boolean = true;
    
    items = [
        this.gItem({ type: 'date', prop: 'holiday_date', label: 'Fecha', required: true, size: 8 }),
        this.gItem({ type: 'button', prop: 'btnAdd', label: 'Agregar', entity: 'holiday', icon: 'add', size: 4, onclick:this.save }),
    ]

    get loading() {
        return this.$store.state.holiday.loading;
    }

    get list() {
        return this.$store.state.holiday.list;
    }

    get totalCount() {
        return this.$store.state.holiday.totalCount;
    }

    get years() {
        return this.gCommonList('years');
    }
    
    async save() {
        if ((this.$refs.entityForm1 as any).validate()) {
            let data = Util.extend(true, {}, this.holiday);
            let newModel = await this.$store.dispatch({
                type: 'holiday/create',
                data: data
            });
            this.$emit('save-success');
            Util.abp.notify.success(this, 'Feriado registrado!');
            this.pagerequest.year = newModel.year;
            this.initCreate();
            this.getpage();
        }
    }

    async deleteItem(m) {
        await this.$store.dispatch({
            type: 'holiday/delete',
            data: m
        });
        this.getpage();
    }

    async getpage() {
        await this.$store.dispatch({
            type: 'holiday/getAll',
            data: this.pagerequest
        });
    }


    initCreate() {
        this.$store.commit('holiday/new');
        this.holiday = Util.extend(true, {}, this.$store.state.holiday.editModel);
    }

    mounted() {
        this.getpage();
        this.initCreate();
    }

    created() {

    }
}